import { ServiceDetailPage } from './ServiceDetailPage';

export function NetworkWifiServices() {
  return <ServiceDetailPage slug="network-wifi" />;
}
